import React, { useEffect, useState } from 'react';
import { Modal, Button, TextField, MenuItem } from '@mui/material';
import request from '../../../Helpers/API';
import Swal from 'sweetalert2';
import { useHistory } from "react-router-dom";
import { RegularExpressions } from '../../../Helpers/RegularExpression';

const ModalAgregarMenu = ({ open, handleClose, datos, setDatos }) => {
    const history = useHistory();
    const [menu, setMenu] = useState({
        idmenu: datos.idmenu,
        idmodulo: datos.idmodulo,
        descripcion: "",
        nomenclatura: "",
        estatus: true,
        modelo: "",
        ruta:"",
    })
    useEffect(() => {
    
        // Verifica si idmenu es diferente de 0, indefinido y -999 antes de realizar la solicitud
        if (datos.idmenu !== 0 && datos.idmenu !== undefined && datos.idmenu !== -999) {
            // setLoader({ ...loader, mostrar: true });
            request
                .get(`Menu/BuscarID?idmenu=${datos.idmenu}`)
                .then((result) => {
                    // setLoader({ ...loader, mostrar: false });
                    setMenu(result)
                })
                .catch((error) => {
                    // setLoader({ ...loader, mostrar: false });
                    Swal.fire("EDITAR MENU", JSON.stringify(error), "error");
                });
        }
    }, [datos.idmenu]);


    const handleCloseModal = () => {
        // Reinicia el estado 'menu' a un array vacío al cerrar el modal
        setMenu([]);
        handleClose();
        setDatos({
            idmenu: -999,
            modulo: "",
        })
    };

    const onGuardar = () => {
        const post = {
            idmenu: menu.idmenu,
            idmodulo: datos.idmodulo,
            descripcion: menu.descripcion,
            nomenclatura: menu.nomenclatura,
            estatus: menu.estatus,
            ruta:menu.ruta,
        }
        request
            .post("Menu", post)
            .then(async () => {
                // setLoader({ ...loader, mostrar: false });
                await Swal.fire({
                    title: "DOCUMENTOS",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
                handleClose();
                history.push("/Permisos/Menus")
            })
            .catch((error) => {
                // setLoader({ ...loader, mostrar: false });
                Swal.fire("DOCUMENTOS", JSON.stringify(error), "error");
            });


    }


    const isValidMenu = (input) => {
        return RegularExpressions.TextWithSpace.test(input);
    }

    const handleMenuChange = (e) => {
        const inputValue = e.target.value;

        if (isValidMenu(inputValue) || inputValue === '') {
            setMenu(menu => ({ ...menu, descripcion: inputValue }));
        }
    }

    return (
        <Modal
            open={open}
        // onClose={handleClose}
        >
            <div className="configuracion-menus-modal-agregar-main-screen">
                <div className="credito-agregar-modal-title">
                    {/* <Agriculture
              color="primary"
              style={{ textAlign: "center", fontSize: 50 }}
            /> */}
                    <div className="filtro-soy-el-titulo-header">
                        <h3>AGREGAR NUEVO MENU </h3>
                    </div>
                </div>
                <div className="filtro-soy-el-titulo-line">
                    <div className="filtro-soy-el-titulo-line-bl"></div>
                    <div className="filtro-soy-el-titulo-line-circle"></div>
                    <div className="filtro-soy-el-titulo-line-br"></div>
                </div>
                <div>

                    <div>
                        <TextField
                            id="clientes-documento"
                            label="Módulo"
                            type="text"
                            disabled
                            value={datos.modulo}
                            // onChange={({ target }) => {
                            //     setMenu({
                            //         ...menu,
                            //         descripcion: target.value,
                            //         // bdocumento: false,
                            //     });
                            // }}
                            sx={{ mb: 2, width: 540 }}
                        />

                    </div>
                    <div className="documentos-intereses-modal-container">

                        <TextField
                            id="clientes-documento"
                            label="Nombre del Menú"
                            type="text"
                            value={menu.descripcion}
                            onChange={handleMenuChange}
                            sx={{ mb: 2, width: 840 }}
                        />

                        <TextField
                            id="clientes-documento"
                            label="Nomenclatura"
                            type="text"
                            value={menu.nomenclatura}
                            onChange={({ target }) => {
                                setMenu({
                                    ...menu,

                                    nomenclatura: target.value,
                                    // bdocumento: false,
                                });
                            }}
                            sx={{ mb: 2, width: 300 }}
                        />
                    </div>
                    <div>
                        <TextField
                            id="RUTA"
                            label="Ruta"
                            type="text"
                            value={menu.ruta}
                            onChange={({ target }) => {
                                setMenu({
                                    ...menu,
                                    ruta: target.value,
                                    // bdocumento: false,
                                });
                            }}
                            sx={{ mb: 2, width: 540 }}
                        />

                    </div>
                </div>
                <div className="credito-crear-interes-modal-button-container ">
                    <Button onClick={handleCloseModal} variant="contained" color="error">
                        Cerrar
                    </Button>
                    <Button variant="contained"
                        onClick={() => onGuardar()}
                    >
                        Agregar
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalAgregarMenu;
